import { reconcileSelectedDisabilities } from '../utils/reconcile-supporting-evidence';

/**
 * Sync treated disability names in supporting evidence and POW
 *
 * Removes orphaned entries from treatedDisabilityNames hashes in both
 * vaTreatmentFacilities and providerFacility, and from powDisabilities in
 * view:isPow, when users have edited or deleted conditions between form saves.
 *
 * This ensures that if a user:
 * 1. Selected conditions in supportingEvidence or POW chapter
 * 2. Edited/renamed a condition, changed its sideOfBody, or deselected a
 *    rated disability in the disabilities chapter
 * 3. Saved the form
 *
 * Orphaned entries will be removed, preventing stale values
 */
export default function reconcileSelectedDisabilitiesMigration(savedData) {
  return {
    ...savedData,
    formData: reconcileSelectedDisabilities(savedData.formData),
  };
}
